/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Data_Title4Inputs */

const en_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content & background work`)
};

const ar_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المحتوى والعمل في الخلفية`)
};

const bn_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কনটেন্ট ও ব্যাকগ্রাউন্ড কাজ`)
};

const de_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt und Hintergrundarbeit`)
};

const es_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido y antecedentes`)
};

const fr_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu et travail de fond`)
};

const pt_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo e trabalho de base`)
};

const zh_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容和背景工作`)
};

const tr_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İçerik ve arka plan çalışması`)
};

const ru_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контент и фоновая работа`)
};

const pl_svc_browser_extensions_data_title4 = /** @type {(inputs: Svc_Browser_Extensions_Data_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treść i prace w tle`)
};

/**
* | output |
* | --- |
* | "Content & background work" |
*
* @param {Svc_Browser_Extensions_Data_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_data_title4 = /** @type {((inputs?: Svc_Browser_Extensions_Data_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Data_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_data_title4(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_data_title4(inputs)
	if (locale === "de") return de_svc_browser_extensions_data_title4(inputs)
	if (locale === "es") return es_svc_browser_extensions_data_title4(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_data_title4(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_data_title4(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_data_title4(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_data_title4(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_data_title4(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_data_title4(inputs)
	return en_svc_browser_extensions_data_title4(inputs)
});
export { svc_browser_extensions_data_title4 as "svc_browser-extensions_DATA_title" }